export { default } from './GetInTouchView';



// WEBPACK FOOTER //
// ./src/components/views/GetInTouchView/index.js